import styled from 'styled-components';

export const ModalStyle = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  min-width: 100%;
  max-width: none;
  height: fit-content;
  display: flex;
  flex-direction: column;
  outline: none;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(100%);
  transition: transform ${props => props.$animationDuration || 300}ms cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;

  &[class*='--after-open'] {
    transform: translateY(0);
  }

  &[class*='--before-close'] {
    transform: translateY(100%);
  }

  @media (min-width: 761px) {
    ${({ $desktopMode, $desktopMaxWidth }) =>
      $desktopMode === 'dialog'
        ? `
      position: relative;
      left: auto;
      right: auto;
      bottom: auto;
      min-width: 0;
      max-width: ${$desktopMaxWidth || '60rem'};
      transform: translateY(2.4rem);

      &[class*='--after-open'] {
        transform: translateY(0);
      }

      &[class*='--before-close'] {
        transform: translateY(2.4rem);
      }
    `
        : `
      max-width: 60rem;
    `}
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  // Anchor to the locked full app height (not 100lvh, which shrinks when the
  // keyboard resizes the WebView on iOS). This keeps the sheet's top stationary
  // when the keyboard opens; the keyboard simply covers the bottom.
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: var(--app-height, 100lvh);
  min-height: var(--app-height, 100lvh);
  z-index: 100000;
  background-color: rgba(7, 8, 8, 0.8);
  overflow: hidden;
  overflow-x: hidden;

  @media (min-width: 761px) {
    ${({ $desktopMode }) =>
      $desktopMode === 'dialog'
        ? `
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2.4rem;
      overflow-y: auto;
    `
        : `
      display: block;
      align-items: flex-end;
    `}
  }

  ${props =>
    props.$customStyles && typeof props.$customStyles === 'object'
      ? Object.entries(props.$customStyles)
          .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`)
          .join('\n')
      : ''}
`;
